import { Box, Divider, Typography, Avatar } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useState, useCallback, useEffect } from "react";
import { getInvoiceData } from "../../features/invoice/invoiceSlice";
import { getPolicy } from "../../features/policy/policySlice";
import AppButton from "../common/AppButton";
import ReturnInvoiceTable from "./return-invoice-table";
import InvoiceTable from "../sales/invoiceTable";
import usePermissions from "../../hooks/usePermissions";
import { getPharmacyImage } from "../../utils/utils";
import { headerData } from "../../utils/constants";

export const ReturnInvoiceModal = ({
  onClose,
  invoiceId,
  returnItem,
  handleSubmit,
  discountedAmount,
  isPrint,
  discountedAmountSingle,
  discountAmountSingle,
  isReturnModal,
}: any) => {


  const dispatch = useAppDispatch();
  const [discountedAmountPrint, setDiscountedAmountPrint] = useState(0);
  const [discountedAmountPrintPre, setDiscountedAmountPrintPre] = useState(0);
  const [discountAmtPrnt, setDiscountAmtPrnt] = useState<any>([]);
  const [discountPerQuantity, setDiscountPerQuantity] = useState<any>([]);
  const [totalDiscountPrntRtrn, setTotalDiscountPrntRtrn] = useState<number>(0);
  const [tableRowData, setTableRowData] = useState<any[]>([]);
  const [rowData, setRowData] = useState<any>();
  const pharmacyId = localStorage?.getItem("pharmacyId") || "";
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  const staffName = localStorage.getItem("UserName");
  if (invoiceId) {
  }
  const imageTimestamp = Date.now();
  // const GetPolicy = useCallback(() => {
  //   dispatch(getPolicy(Number(pharmacyId)))
  // }, [dispatch, pharmacyId]);

  // useEffect(() => {
  //   if (pharmacyId)
  //     GetPolicy();
  // }, [pharmacyId, GetPolicy]);

  const getInvoice = useCallback(async () => {
    if (invoiceId) {
      const obj: any = {
        pharmacy_id: pharmacyId,
        invoice_id: invoiceId,
      };
      try {
        const res = await dispatch(getInvoiceData(obj));

        if (res?.payload) {
          setRowData(res?.payload);
        }
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    }
  }, [dispatch, invoiceId, pharmacyId]);

  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  const {
    policyPayload,
  }: any = useAppSelector((state) => state.policy);

  useEffect(() => {
    if (rowData?.sales?.length > 0) {
      const newData = rowData?.sales?.map((item: any) => ({
        "Item(s)": (
          <>
            {item?.medicine_name}
            <span style={{ fontSize: "16px", marginLeft: "3px" }}>
              {((d?: string) => {
                const cleaned = (d ?? "").replace(/\bnull\b/gi, "").trim();
                return cleaned || "";
              })(item?.batch?.pharmacy_medicine?.dose)}
            </span>
          </>
        ),
        QTY: item?.quantity_sold,
        Price: item?.sell_price,
        Amt: item?.amount_to_be_paid,
        Discount: item?.discount_amount,
        "Payable Amt": item?.amount_after_discount,
      }));
      setTableRowData(newData);
    } else {
      setTableRowData([]);
    }
  }, [rowData]);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };
  const date = rowData?.invoice_date && formatDate(rowData?.invoice_date);
  const time =
    rowData?.created_at &&
    new Date(rowData?.created_at).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

  const dateReturn = rowData?.return_at && formatDate(rowData?.return_at);
  const timeReturn =
    rowData?.return_at &&
    new Date(rowData?.return_at).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

  const pharmacyName = rowData?.pharmacy?.name;
  const userName = rowData?.add_by_admin ? "Admin" : rowData?.created_by?.name;
  const pharmacyAddress = rowData?.pharmacy?.address?.address;
  const licenseNo = rowData?.pharmacy?.pharmacy_auth?.license_number;
  const phone = rowData?.pharmacy?.phone_number;
  const ID = rowData?.id || "";
  const discount = rowData?.discount_Amount;
  const discountPercentage = rowData?.discount_percentage;
  const netAmount = rowData?.after_discount_amount;
  const purchasedItems = new Set();
  const return_by_user = rowData?.updatedSales?.map(
    (item: any) => item?.staff?.name
  );


  // Iterate over tableRowData to add each unique purchased item to the set
  tableRowData?.forEach((item: any) => {
    purchasedItems?.add(item["Purchased Item"]);
  });

  // Calculate the total number of unique purchased items
  const totalItems = purchasedItems?.size;
  const totalQuantity = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.QTY,
    0
  );
  const totalAmount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr?.Amt,
    0
  );
  const totalDiscount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr?.Discount,
    0
  );
  const totalDiscountedAmount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr["Payable Amt"],
    0
  );

  // Calculate total amount after discounts for each item
  const afterDiscAmtPrnt = rowData?.sales?.map((item: any) => {
    return item?.quantity_sold * item?.sell_price;
  });

  // Calculate the total amount (sum of all amounts)
  const totalAmounts = afterDiscAmtPrnt?.reduce(
    (acc: number, curr: number) => acc + curr,
    0
  );

  // Apply the overall discount percentage to get the discount value
  const overallDiscountPrintSingle =
    (totalAmounts * rowData?.discount_percentage) / 100;

  const afterDiscAmtPrntTot = returnItem?.map((item: any) => {
    return item?.quantity_return * item?.sell_price;
  });

  const netAmountPrint = totalAmount - totalDiscount;

  const handleSaveInvoice = () => {
    onClose(); // Close the modal
    localStorage?.removeItem("salesData");
    handleSubmit();
  };

  const handleSaveAndPrintInvoice = () => {
    onClose(); // Close the modal
    localStorage?.removeItem("salesData");
    handleSubmit();
    window?.print(); // Trigger print dialog
  };

  const handlePrintOnly = () => {
    onClose(); // Close the modal
    window?.print();
  };

  const totalReturnMedicineQuantity = Array?.isArray(returnItem)
    ? returnItem?.reduce((total, item) => {
      // Ensure item has remainingQuantity and it's a number
      return total + parseFloat(item?.quantity_to_be_returned || 0);
    }, 0)
    : 0;

  const totalReturnMedicineAmt = Array?.isArray(returnItem)
    ? returnItem?.reduce((total, item) => {
      // Ensure item has remainingQuantity and it's a number
      return total + (item?.amount_to_be_return || 0);
    }, 0)
    : 0;

  const totalReturnMedicineAmtPrint = Array?.isArray(returnItem)
    ? returnItem?.reduce((total, item) => {
      // Ensure item has remainingQuantity and it's a number
      return total + (item?.sell_price * item?.quantity_return || 0);
    }, 0)
    : 0;

  const uniqueMedicineNames = new Set(
    returnItem?.map((item: any) => item?.medicine_name)
  );
  const uniqueMedicineCount = uniqueMedicineNames?.size;

  const hasDiscountPercentagePrevious = tableRowData?.some(
    (entry: any) => entry?.Discount
  );

  useEffect(() => {
    const totalAmountToBeReturned = returnItem?.reduce(
      (total: number, item: any) =>
        total + item?.sell_price * item?.quantity_return,
      0
    );

    const discountAmount =
      (totalAmountToBeReturned * (discountPercentage || 0)) / 100;
    setDiscountedAmountPrint(discountAmount);
  }, [returnItem, discountPercentage]);

  useEffect(() => {
    const totalAmountToBeReturned = returnItem?.reduce(
      (total: number, item: any) =>
        total + item?.sell_price * item?.quantity_return,
      0
    );
    const totalDiscountToBeReturned = returnItem?.reduce(
      (total: number, item: any) =>
        total + item?.discount_amount * item?.quantity_return,
      0
    );
    setDiscountedAmountPrintPre(totalDiscountToBeReturned);
  }, [returnItem, discountPercentage]);

  const totalAmtPayable = totalReturnMedicineAmt - discountedAmount;
  const totalAmtPayablePrint =
    totalReturnMedicineAmtPrint - discountedAmountPrint;

  useEffect(() => {
    if (isPrint) {
      const updatedDiscounts = returnItem?.map(
        (row: any) => row?.discount_amount
      );
      setDiscountPerQuantity(updatedDiscounts);
    }
  }, [isPrint, returnItem]);

  const totalAmtPayableSingleMedPrint =
    totalReturnMedicineAmtPrint - discountedAmountPrintPre;

  useEffect(() => {
    // Calculate discounts
    const calculatedDiscounts = returnItem?.map((item: any) => {
      return (
        item?.quantity_to_be_returned *
        item?.rate *
        (item?.discountPercSingle / 100)
      );
    });

    // Calculate the total discount
    const total = calculatedDiscounts.reduce(
      (accumulator: any, currentValue: any) => {
        return accumulator + currentValue;
      },
      0
    );

    setDiscountAmtPrnt(calculatedDiscounts);
    setTotalDiscountPrntRtrn(total); // Store total discount in state
  }, [returnItem]);

  // Log the total discount
  useEffect(() => { }, [totalDiscount]);

  const totalAmtPayableSingleMed =
    totalReturnMedicineAmt - totalDiscountPrntRtrn;

  return (
    <>
      <style>
        {`
      @media print {
        @page {
          margin: 0; /* Removes the default margin that may add header and footer */
        }
        body {
          margin: 1cm; /* Adjust the margin as needed */
        }
        header, footer {
          display: none; /* Hides any header or footer content */
        }
      }
    `}
      </style>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          textAlign: "center",
        }}
      >
        <Box
          sx={{ display: " flex", margin: "auto", alignItems: "center", }}
        >
          <Avatar
            sx={{ bgcolor: "white", height: "60px", width: "60px" }}
            src={`${getPharmacyImage(pharmacyId)}&t=${imageTimestamp}`}
          >
          </Avatar>
        </Box>
        <Box
          sx={{
            fontWeight: 600,
            fontSize: "35px",
            padding: "7px",
            lineHeight: "38px",
            //wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          {pharmacyName}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
            //
          }}
        >
          {pharmacyAddress}
        </Box>
        <Box
          sx={{
            // bgcolor: "black",
            color: "black",
            textAlign: "center",
            fontWeight: 500,
            paddingY: "9px",
            fontSize: "27px",
            lineHeight: "18px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          Phone # {phone}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
            // wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          License No. {licenseNo}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            mt: 1,
            textAlign: "center",
            fontWeight: 400,
            fontSize: "23px",
            lineHeight: "18px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          <Box>
            Inv. No: {ID}
          </Box>
          <Box>
            C. By: {userName}
          </Box>
          <Box>
            {date} {time}{" "}
          </Box>
        </Box>
      </Box>

      <Box sx={{ mt: 4, width: "100%" }}>
        <InvoiceTable
          headerData={headerData}
          rowData={tableRowData}
          totalItems={totalItems}
          totalQuantity={totalQuantity}
          totalAmount={totalAmount}
          totalDiscount={totalDiscount}
          totalDiscountedAmount={totalDiscountedAmount}
          discountPercentage={discountPercentage}
          discount={discount}
          hasDiscountPercentagePrevious={hasDiscountPercentagePrevious}
          isPrint={isPrint}
        />
      </Box>

      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          //justifyContent: "flex-end",
          //alignItems: "flex-end", // Align items to the right
          fontWeight: 500,
          fontSize: "24px",
          lineHeight: "18px",
          mt: 3,
          marginRight: 3, // Add margin to the right
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            //width: "50%",
          }}
        >
          <Box>Gross Total: </Box>
          <Box marginLeft={1}>Rs. {Math.round(totalAmount)?.toFixed(2)}</Box>
        </Box>

        {
          hasDiscountPercentagePrevious &&
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              //width: "50%",
            }}
          >
            <Box>Discount:</Box>
            {isPrint && hasDiscountPercentagePrevious ? (
              <Box marginLeft={1}>Rs. {Math.round(totalDiscount)?.toFixed(2)}</Box>
            ) : isPrint && !hasDiscountPercentagePrevious ? (
              <Box marginLeft={1}>
                Rs. {Math.round(overallDiscountPrintSingle)?.toFixed(2)}
              </Box>
            ) : hasDiscountPercentagePrevious ? (
              <Box marginLeft={1}>Rs. {Math.round(discount)?.toFixed(2)}</Box>
            ) : (
              <Box marginLeft={1}>
                Rs. {Math.round(discount)?.toFixed(2)} ({discountPercentage}%)
              </Box>
            )}
          </Box>
        }

        {hasDiscountPercentagePrevious &&
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              //width: "50%",
            }}
          >
            <Box>Net Amount:</Box>
            {isPrint && hasDiscountPercentagePrevious ? (
              <Box marginLeft={1}>Rs. {Math.round(netAmountPrint)?.toFixed(2)}</Box>
            ) : (
              <Box marginLeft={1}>Rs. {Math.round(netAmount)?.toFixed(2)}</Box>
            )}
          </Box>}
      </Box>

      <Divider sx={{ mt: 4 }} />

      <Box
        sx={{
          display: "flex",
          mt: 2,
          flexDirection: "column",
          gap: "15px",
          textAlign: "center",
          fontWeight: 500,
          fontSize: "27px",
          lineHeight: "25px",
          wordWrap: "break-word", // Ensure text wraps within the box
        }}
      >
        <Box
          sx={{
            fontSize: "27px",
          }}
        >
          Return Invoice
        </Box>
        <Box
          sx={{
            fontSize: "27px",
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {dateReturn ? dateReturn : new Date().toLocaleDateString()}
          &nbsp;&nbsp;
          {timeReturn ? timeReturn : new Date().toLocaleTimeString()}
        </Box>
        <Box sx={{ fontSize: "27px" }}>
          Returned By:{" "}
          {isReturnModal ? return_by_user?.join(" , ") : Account_Type === 0 ? "Admin" : staffName}
        </Box>
      </Box>

      <Box sx={{ mt: 4, width: "100%" }}>
        <ReturnInvoiceTable
          totalReturnMedicineQuantity={totalReturnMedicineQuantity}
          uniqueMedicineCount={uniqueMedicineCount}
          totalReturnMedicineAmt={totalReturnMedicineAmt}
          returnItem={returnItem}
          isPrint={isPrint}
          discountedAmountSingle={discountedAmountSingle}
          discountAmountSingle={discountAmountSingle}
          hasDiscountPercentagePrevious={hasDiscountPercentagePrevious}
          discountPerQuantity={discountPerQuantity}
        />
      </Box>

      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          //justifyContent: "flex-end",
          //alignItems: "flex-end", // Align items to the right
          fontWeight: 500,
          fontSize: "24px",
          lineHeight: "18px",
          mt: 3,
          marginRight: 3, // Add margin to the right
        }}
      >
        {hasDiscountPercentagePrevious && <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            //width: "50%",
          }}
        >
          <Box>Discount Returned:</Box>
          {isPrint && hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>Rs. {discountedAmountPrintPre?.toFixed(2)}</Box>
          ) : isPrint && !hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>Rs. {discountedAmountPrint?.toFixed(2)}</Box>
          ) : hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>Rs. {totalDiscountPrntRtrn?.toFixed(2)}</Box>
          ) : (
            <Box marginLeft={1}>
              Rs. {discountedAmount?.toFixed(2)} ({discountPercentage}%)
            </Box>
          )}
        </Box>}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            //width: "50%",
          }}
        >
          <Box>Return Item(s) Amt:</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {isPrint
              ? totalReturnMedicineAmtPrint?.toFixed(2)
              : totalReturnMedicineAmt?.toFixed(2)}
          </Box>
        </Box>
        {/* <Divider sx={{ mt: 2 }} /> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            //width: "50%",
          }}
        >
          <Box>Total Amt Payable:</Box>

          {isPrint && hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>
              {" "}
              Rs. {totalAmtPayableSingleMedPrint?.toFixed(2)}
            </Box>
          ) : isPrint && !hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>Rs. {totalAmtPayablePrint?.toFixed(2)}</Box>
          ) : hasDiscountPercentagePrevious ? (
            <Box marginLeft={1}>Rs. {totalAmtPayableSingleMed?.toFixed(2)}</Box>
          ) : (
            <Box marginLeft={1}>Rs. {totalAmtPayable?.toFixed(2)}</Box>
          )}
        </Box>
      </Box>
      <Divider sx={{ mt: 2 }} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            textAlign: "center",
            fontWeight: 400,
            fontSize: "22px",
            lineHeight: "18px",
            wordBreak: "break-word",

            p: 2,
          }}
        >
          Software By E-Mareez Care, Phone# 03095558054
        </Box>

        {(Account_Type === 0 || (isPermissions?.add && Account_Type === 1)) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              "@media print": {
                display: "none", // Hide this section when printing
              },
            }}
          >
            {!isPrint ? (
              <>
                <AppButton
                  variant="contained"
                  color="primary"
                  title="Save Invoice"
                  sx={{ width: "48%" }}
                  onClick={handleSaveInvoice}
                />
                <AppButton
                  variant="contained"
                  color="primary"
                  title="Save & Print Invoice"
                  sx={{ width: "48%", backgroundColor: "#01A768" }}
                  onClick={handleSaveAndPrintInvoice}
                />
              </>
            ) : (
              <AppButton
                variant="contained"
                color="primary"
                title="Print Invoice"
                sx={{ width: "100%" }}
                onClick={handlePrintOnly}
              />
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
